var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMerchapp = function SvgMerchapp(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#29AAE1",
    d: "M14.354 10.78c-.838 0-1.524-.686-1.524-1.525V8.118c0-.838.686-1.524 1.524-1.524s1.524.685 1.524 1.524v1.137c0 .839-.685 1.525-1.524 1.525"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6B3D9",
    d: "M5.64 4.186c-.838 0-1.524-.686-1.524-1.524V1.525C4.116.686 4.802 0 5.64 0c.839 0 1.525.686 1.525 1.525v1.137c0 .839-.686 1.524-1.525 1.524"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D86C6",
    d: "M5.64 5.692c-3.11 0-5.64 2.53-5.64 5.64V23.02h2.565V11.333c0-1.696 1.38-3.076 3.075-3.076 1.696 0 3.076 1.38 3.076 3.076V23.02h2.562v.243l.003-.174V11.333c0-3.11-2.53-5.641-5.64-5.641"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D86C6",
    d: "M14.354 12.285c-1.133 0-2.189.336-3.073.914-1.5.977-2.507 2.647-2.565 4.553l-.003.174v5.29c.002-.043.003-.084.003-.127v-.069h2.562v-5.094c0-.043.001-.085.003-.127.067-1.638 1.42-2.949 3.073-2.949 1.696 0 3.076 1.38 3.076 3.076v5.094h2.565v-5.094c0-3.11-2.53-5.64-5.64-5.64"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMerchapp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/merchapp.9c58a10d.svg";
export { ForwardRef as ReactComponent };